import moment from 'moment'

// - Headers Facturas
export default [
    {
        text: 'Folio',
        fieldType: 'computed',
        computed: ({ folio }) => {
            return folio.toLocaleString('es')
        },
        sortable: false,
    },
    {
        text: 'Documento',
        fieldType: 'computed',
        computed: ({ document_type }) => {
            return document_type
        },
        sortable: false,
    },
    {
        // Nombre fantasía
        text: 'Proveedor',
        fieldType: 'computed',
        computed: ({ pch_provider }) => {
            return pch_provider.business_name
        },
        sortable: false,
    },
    {
        text: 'Rut',
        fieldType: 'computed',
        computed: ({ pch_provider }) => {
            return pch_provider.rut
        },
        sortable: false,
    },
    {
        text: 'Vencimiento',
        fieldType: 'computed',
        computed: ({ payment_date }) => {
            if (payment_date && payment_date !== null) {
                return moment(payment_date.substr(0, 10), 'YYYY-MM-DD').format('DD-MM-YYYY')
            } else {
                return 'Sin definir'
            }
        },
        sortable: true,
    },
    {
        // Monto total de Factura
        text: 'Monto',
        fieldType: 'computed',
        computed: ({ total }) => {
            return '$ ' + total.toLocaleString('es')
        },
        sortable: false,
    },
    {
        text: 'Estado',
        fieldType: 'computed',
        computed: ({ pch_provider_debt_to_pay, emission_date }) => {
            var moment = require('moment')
            const today = new Date()
            const dataResult = moment(emission_date, 'YYYY-MM-DD').isSameOrAfter(today)
            //-
            if (pch_provider_debt_to_pay !== null) {
                const total = pch_provider_debt_to_pay.total
                const total_pagado = pch_provider_debt_to_pay.total_paid
                //-
                if (dataResult) {
                    if (total == total_pagado) {
                        return 'Pagado'
                    } else if (total > total_pagado) {
                        return 'Pendiente'
                    }
                } else if (!dataResult) {
                    return 'Atrasado'
                }
            } else {
                return 'Pago indefinido'
            }
        },
        sortable: false,
    },
]
